import React, { Component, PropTypes } from 'react';
import { Modal } from 'antd';

export default class ExpandableImage extends Component {

  state = {
    showModal: false
  };

  toggleModal = () => {
    this.setState((state) => ({ showModal: !state.showModal }));
  };

  renderFile = (className) => {
    return (
      <img className={ className } src={ this.props.source } onClick={ this.toggleModal } />
    );
  };

  render() {
    return (
      <div >
        { this.renderFile('s-image') }
        <Modal
          visible={ this.state.showModal }
          footer={ null }
          onCancel={ this.toggleModal }
          closable={ false }
        >
          { this.renderFile('expanded-image', true) }
        </Modal >
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/expandable-image/ExpandableImage.jsx